import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "../../core/utils";

// core
import { API } from "../../core/api";
import { getURL } from "../../core/utils";
import { defaultImage } from "../../core/data";

// components
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import { IsActive } from "../../components/IsActive";
import { Note } from "../../components/Note";
import { Table, Image, Input, Button, Select } from "antd";

const { Column } = Table;
const { Option } = Select;

export const Products = () => {
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState(null);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [isActive, setIsActive] = useState(null);
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getBrands = () => {
    setIsLoading(true);
    // API.get
    //   .brands()
    //   .then((response) => {
    //     if (response.success) {
    //       setBrands(response.data);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const getCategories = () => {
    // API.get
    //   .categories()
    //   .then((response) => {
    //     if (response.success) {
    //       setCategories(response.data);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const getProducts = (
    page,
    limit,
    is_active,
    search,
    brand_id,
    category_id
  ) => {
    // API.get
    //   .products(page, limit, is_active, search, brand_id, category_id)
    //   .then((response) => {
    //     if (response.success) {
    //       setProducts(response.data);
    //       setPagination(response.pagination);
    //       history.query({
    //         page: response.pagination.page,
    //         limit: response.pagination.limit,
    //         is_active,
    //         search,
    //         brand_id,
    //         category_id,
    //       });
    //       setIsLoading(false);
    //     } else {
    //       Note.error(response.message);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoading(false);
    //   });
  };

  useEffect(() => {
    let query = history.query();
    getBrands();
    getCategories();
    getProducts(
      query.page,
      query.limit,
      query.is_active,
      query.search,
      query.brand_id,
      query.category_id
    );
    setIsActive(query.is_active || null);
    setSearch(query.search);
    setBrand(query.brand_id || null);
    setCategory(query.category_id || null);
    // eslint-disable-next-line
  }, []);

  const changePage = (page, limit) => {
    let query = history.query();
    getProducts(
      page,
      limit,
      query.is_active,
      query.search,
      query.brand_id,
      query.category_id
    );
    // history.query({ page, limit });
  };

  const filterData = () => {
    setIsLoading(true);
    let query = history.query();
    getProducts(query.page, query.limit, isActive, search, brand, category);
  };

  return (
    <>
      <Header title="کالاها" activeItem="products" />
      <Loading isLoading={isLoading}>
        <div className="products-page mb-20">
          <div className="flex-row flex-content-space-between flex-wrap py-10 px-20">
            <Input
              className="input-black border-black w-100 my-5"
              placeholder="جستجو نام کالا"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Select
              className="border-black w-25 sm:w-100 my-5"
              showSearch
              optionFilterProp="name"
              value={brand}
              onChange={(value) => setBrand(value)}
            >
              <Option value={null} name="همه برندها">
                همه برندها
              </Option>
              {brands.map((brand) => (
                <Option value={brand.id.toString()} name={brand.name}>
                  {brand.name}
                </Option>
              ))}
            </Select>
            <Select
              className="border-black w-25 sm:w-100 my-5"
              showSearch
              optionFilterProp="name"
              value={category}
              onChange={(value) => {
                setCategory(value);
              }}
            >
              <Option value={null} name="همه دسته‌ها">
                همه دسته‌ها
              </Option>
              {categories.map((category) => (
                <Option value={category.id.toString()} name={category.name}>
                  {category.name}
                </Option>
              ))}
            </Select>
            <Select
              className="border-black w-25 sm:w-100 my-5"
              value={isActive}
              onChange={(value) => {
                setIsActive(value);
              }}
            >
              <Option value={null} name="همه وضعیت‌ها">
                همه وضعیت‌ها
              </Option>
              <Option value={"1"} name="فعال">
                فعال
              </Option>
              <Option value={"0"} name="غیرفعال">
                غیرفعال
              </Option>
            </Select>
            <Button
              className="button-secondary w-20 sm:w-100 my-5"
              onClick={filterData}
            >
              فیلتر
            </Button>
          </div>
          <Table
            size="small"
            scroll={{ x: 640 }}
            dataSource={products}
            pagination={{
              position: ["bottomCenter"],
              current: pagination.page,
              pageSize: pagination.limit,
              total: pagination.count,
              onChange: changePage,
            }}
          >
            <Column
              title="تصویر"
              dataIndex="image"
              key="image"
              render={(image) => (
                <Image
                  className="product-image"
                  src={getURL(image)}
                  fallback={defaultImage}
                  alt="image"
                />
              )}
            />
            <Column
              title="کد"
              dataIndex="id"
              key="id"
              render={(id) => <Link to={`/products/${id}/`}>{id}</Link>}
            />
            <Column title="نام" dataIndex="name" key="name" />
            <Column title="برند" dataIndex={["brand", "name"]} key="brand" />
            <Column
              title="دسته"
              dataIndex={["category", "name"]}
              key="category"
            />
            <Column title="واحد" dataIndex="unit" key="unit" />
            <Column
              title="وضعیت"
              dataIndex="is_active"
              key="is_active"
              render={(is_active) => <IsActive value={is_active} />}
            />
          </Table>
        </div>
      </Loading>
    </>
  );
};
